<script>
export default {
    data: () => ({
        show : true
    }),
    methods : {
        accept() {
            this.show = false;
            localStorage.setItem("cookies", true);
        }
    },
    computed : {
        unacceptedCookie () {
            return localStorage.getItem("cookies") === null && this.show;
        }
    }
}
</script>
<template>
<div v-if="unacceptedCookie" class="py-4 px-8 w-full gs:grid bg-white l-0 r-0 mx-a">
    <div class="flex flex-column md:flex-row justify-content-center md:justify-content-baseline align-items-center w-full">
        <span class="tx-14 block mb-3 md:mb-0 md:mr-4">
            Este sitio utiliza cookies para darte una mejor experiencia de navegación. Al utilizar autodeal aceptas su uso.
        </span>
        <button @click="accept" class="btn btn--green-ad flex">
            Aceptar cookies
        </button>
        <button @click="accept" class="btn btn--dark-ad-outline ml-2 flex">
            Cerrar
        </button>
    </div>
</div>
</template>

<style>

</style>